import { Container } from '@mui/material';
import { useAuth } from 'contexts';
import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './login.scss';

const Logout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const logoutThenNavigate = useCallback(async () => {
    logout();
    setTimeout(() => navigate('/login', { replace: true }));
  }, [logout, navigate]);

  useEffect(() => {
    logoutThenNavigate();
  }, [logoutThenNavigate]);

  return <Container className="login-banner" disableGutters maxWidth={false} />;
};

export default Logout;
